<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import AcademicYearServices from '@/services/api/academicyear.api'
import providerApi from '@/services/api/provider.api'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@//modules/report/document'

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Citas Completadas No Confirmadas',
      routes: ['Informes', 'Citas Completadas No Confirmadas'],
    },
    model: {
      search: {
        collections: {
          academicYears: [],
          providers: [],
          dateTo: [],
          dateFrom: [],
        },
        filters: {
          academicYear: null,
          provider: null,
          dateTo: null,
          dateFrom: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'description',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un año académico.',
          validations: 'required',
          class: 'col-md-2',
          clearable: false,
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
          onChanged: this.onChangeAcademicYear,
        },
        {
          name: 'provider',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Proveedor',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar Proveedor',
          validations: 'required',
          clearable: false,
          class: 'col-md-6',
          options: this.model.search.collections.providers,
          value: this.model.search.filters.provider,
          disabled:
            this.model.search.collections.providers.length <= 0 ||
            this.model.search.collections.providers.length == 1,
        },
        {
          name: 'dateFrom',
          component: 'custom-date-picker',
          label: 'Fecha Desde',
          placeholder: 'Seleccionar Fecha Desde',
          error: 'Fecha Desde es requerida.',
          validations: 'required',
          class: 'col-md-2',
          classContainer: 'date-width-container',
          maxDate: new Date(),
          value: this.model.search.filters.dateTo,
        },
        {
          name: 'dateTo',
          component: 'custom-date-picker',
          label: 'Fecha Hasta',
          placeholder: 'Seleccionar Fecha Hasta',
          error: 'Fecha Hasta es requerida.',
          validations: 'required',
          class: 'col-md-2',
          classContainer: 'date-width-container',
          maxDate: new Date(),
          value: this.model.search.filters.dateTo,
        },
      ]
    },
  },
  async mounted() {
    await this.setFilters()
  },
  methods: {
    hasValue(param) {
      return param !== null && param !== undefined
    },
    async setFilters() {
      await AcademicYearServices.getCurrentYearAcademicYears().then(
        (res) => (this.model.search.collections.academicYears = res.data)
      )
    },
    async onChangeAcademicYear() {
      this.model.search.filters.provider = null
      await this.getProvider()
    },
    async getProvider() {
      await providerApi
        .getAllProvidertCompaniesByYear({
          academicYearId: this.model.search.filters.academicYear?.id,
        })
        .then((res) => {
          this.model.search.collections.providers = res.data

          if (res.data.length == 1) {
            this.model.search.filters.provider = res.data[0]
          }
        })
    },
    async onHandlerSearch() {
      this.process()
    },
    async process() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate()

      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        )
        return
      }

      await ReportServices.getReport(
        'reportnonconfirmedcompletedappointments',
        {
          academicYearId: this.model.search.filters.academicYear?.id,
          providerId: this.model.search.filters.provider?.id,
          fechaDesde: this.model.search.filters.dateFrom,
          fechaHasta: this.model.search.filters.dateTo,
        }
      ).then((res) => DocumentServices.Download(res.data))
    },
  },
}
</script>
